import { Component, OnInit, inject } from '@angular/core';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {

  private keycloak = inject(Keycloak);
  private translate = inject(TranslateService);

  userRoles: string[] = [];
  username = '';

  ngOnInit() {
    const realmAccess = this.keycloak.realmAccess;
    this.userRoles = realmAccess?.roles || [];
    this.keycloak.loadUserProfile().then((profile: KeycloakProfile) => {
      this.username = profile.username || profile.email || 'Użytkownik';
    });
  }

  logout() {
    void this.keycloak.logout({ redirectUri: window.location.origin }).catch(() => {
      window.location.href = `${environment.keycloakUrl}/realms/${environment.realm}/protocol/openid-connect/logout?client_id=${environment.clientId}&post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
    });
  }

  getTitle(): string {
    return this.translate.instant('accessDenied.title');
  }

  getMessage(): string {
    return this.translate.instant('accessDenied.message');
  }

  getDescription(): string {
    return this.translate.instant('accessDenied.description');
  }

  getLogoutButtonText(): string {
    return this.translate.instant('accessDenied.logoutButton');
  }
}
